"use client";
import { Link } from "@/i18n/Link";
import { classed, clsx } from "@frend-digital/ui";
import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import styles from "./NavigationMenu.module.css";
import { createContext, use, type ComponentProps } from "react";

export const NavigationMenuRoot = classed(NavigationMenuPrimitive.Root, styles.Root);

export const NavigationMenuList = classed(NavigationMenuPrimitive.List, styles.List);

export const NavigationMenuTrigger = ({
	className,
	...rest
}: ComponentProps<typeof NavigationMenuPrimitive.Trigger>) => {
	return <NavigationMenuPrimitive.Trigger {...rest} className={clsx(className, styles.Trigger)} />;
};

export const NavigationMenuTriggerLink = classed(NavigationMenuPrimitive.Link, styles.Trigger);

export const NavigationMenuItem = classed(NavigationMenuPrimitive.Item, styles.Item);

export const NavigationMenuContent = classed(NavigationMenuPrimitive.Content, styles.Content);

export const NavigationMenuContentList = classed(NavigationMenuPrimitive.List, styles.ContentList);

export const NavigationMenuLink = ({
	href,
	children,
}: {
	href: string;
	children: React.ReactNode;
}) => {
	return (
		<NavigationMenuPrimitive.Link asChild>
			<Link href={href}>{children}</Link>
		</NavigationMenuPrimitive.Link>
	);
};

export const NavigationMenuViewport = ({
	className,
}: {
	className?: string;
}) => {
	return (
		<div className={clsx(styles.ViewportPosition, className)}>
			<NavigationMenuPrimitive.Viewport className={styles.Viewport} />
		</div>
	);
};

export const MenuLinks = classed.menu(styles.links);
export const MenuTitle = classed.p(styles.title);
export const NavigationMenuPrimitiveLink = NavigationMenuPrimitive.Link;

export const NavigationMenuContext = createContext<true | undefined>(undefined);

export const NavigationMenuProvider = ({ children }: { children: React.ReactNode }) => {
	return <NavigationMenuContext.Provider value={true}>{children}</NavigationMenuContext.Provider>;
};

export const useNavigationMenuContext = () => use(NavigationMenuContext);
